import { CloseOutlined, PlusOutlined } from "@ant-design/icons"
import { Form, Input, Modal, Select, FormProps, FormInstance } from "antd"
import { ChangeEvent, useEffect, useRef, useState } from "react"
import './style.scss'
import { addCategoryCar } from "../../../../../api/categoryCar/categoryCarApi"
import { useForm } from "antd/lib/form/Form"
interface ModalProps {
  isOpen: boolean
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}
const ModalCreateVersionCar: React.FC<ModalProps> = ({
  isOpen,
  onSubmitFormModal, closeModal
}) => {


  const imgRef = useRef<HTMLInputElement>(null);
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);


  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setUploadedFile(file);
  };

  const handleUploadClick = (event: React.MouseEvent) => {

    event.preventDefault();
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement | null;
    if (inputElement) {
      inputElement.click();
    }
  };

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    // const result = await addCategoryCar(values.namebrand, values.codebrand, uploadedFile)
    // if (result?.status) {
    //   onSubmitFormModal?.(true, result?.message)
    // } else {
    //   onSubmitFormModal?.(false, result?.message)
    // }
  }

  useEffect(() => {
    if (isOpen) {
    } else {
      form.resetFields()
      setUploadedFile(null)
      if (imgRef.current) {
        imgRef.current.value = '';
      }

    }
  }, [isOpen])
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
      requiredMark={true}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">
            Tạo mới phiên bản xe
          </span>
          <CloseOutlined className="text-base text-8B8B8B"
            onClick={closeModal}
          />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content ant-modal-size"
        closeIcon={false}
        footer={
          <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
            <span className="text-sm text-98A2B3 cursor-pointer"
              onClick={closeModal}
            >
              Huỷ
            </span>
            <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
              onClick={submitForm}>
              Lưu
            </button>
          </div>
        }
      >
        <div className="px-6 py-2 d-flex flex-column gap-2">
          <div className="d-flex gap-2 flex-column pt-2">
            <div className="d-flex flex-column gap-4">

              <Form.Item
                label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="carLineId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn dòng xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="typeVehicleId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn loại xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Thương hiệu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="typeVehicleId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn thương hiệu xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Mẫu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="typeVehicleId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn thương hiệu xe!' }]}
              >
                <Select />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Tên phiên bản xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="namebrand"
                rules={[{ required: true, message: 'Nhập tên phiên bản xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Tên phiên bản xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Mã phiên bản xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}

                layout="vertical"
                name="codebrand"
                rules={[{ required: true, message: 'Nhập mã phiên bản xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Mã phiên bản xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>


        </div>

      </Modal>
    </Form>
  )
}
export default ModalCreateVersionCar
